import { getCurrentInstance } from 'vue';

export function useGlobals() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('useGlobals must be used inside setup()');
  }

  const gp = instance.appContext.config.globalProperties;

  return {
    $moment: gp.$moment,
    $validateMsg: gp.$validateMsg,
    $formatDate1: gp.$formatDate1,
    $formatDate2: gp.$formatDate2,
    $formatDate21: gp.$formatDate21,
    $formatDate3: gp.$formatDate3,
    $CalAge: gp.$CalAge,
    $buildFormData: gp.$buildFormData,
  };
}
